import {useAddNotification} from '@logistics-frontend/blocks'
import {setHandleError} from '@logistics-frontend/blocks/usetransition/useTransition'
import {ServerError} from '@logistics-frontend/core/utils/network'
import {get, getErrorMessage} from '@logistics-frontend/utils'
import {useEffect} from 'react'

export const ErrorNotification = () => {
  const addNotification = useAddNotification()

  useEffect(() => {
    setHandleError((error?: unknown) => {
      if (error instanceof Error) {
        let errorMessage = getErrorMessage(error)

        if (error instanceof ServerError) {
          const yatraceId = get('headers.x-yatraceid', error)

          if (yatraceId) {
            errorMessage += `\nX-Yatraceid: ${yatraceId}`
          }
        }

        addNotification(errorMessage, {
          type: 'error',
        })
      }
    })

    return () => {
      setHandleError(undefined)
    }
  }, [addNotification])

  return null
}
